<div class="pathway-tree-view">
  <div class="tree-viewer">
    <ispm-json-tree-viewer
      [treeNodes]="data"
      [useFilter]="true"
      [showButtons]="true"
      [showButtonsAbove]="true"
      [maxHeight] = "this.payload.config.maxHeight"
      [isExpanded]="isExpanded"
      [nodesStateMap] = "nodeStateMap"
      [contextMenuItems]="contextMenu"
      (executeCommand)="onNodeEvent($event)"
     ></ispm-json-tree-viewer>
  </div>

</div>
